export default "__VITE_ASSET__9973057b__"